<template lang="pug">
  div
    v-chip(:color="statusItem.color" text-color="white")
      v-icon(left v-if="statusItem.icon") {{ statusItem.icon }}
      | {{ statusItem.label | uppercase }}
</template>

<script>
  export default {
    name: 'report-status',

    props: {
      status: {
        required: true
      }
    },

    computed: {
      statusItem () {
        const { status } = this

        if (status === 'PUBLICADO') return this.mountItem(status, 'success', 'check')
        else if (status === 'ANDAMENTO') return this.mountItem(status, 'warning', 'more_horiz')
        else if (status === 'LAUDAR') return this.mountItem(status, 'primary', 'more_horiz')
        else return this.mountItem(status, 'error', false)
      }
    },

    methods: {
      mountItem (label, color, icon) {
        return {label, color, icon}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ultra-fetal/reportStatus/index.vue